module.exports = __webpack_public_path__ + "media/images/roku/header-mobile-67d956130891e6dc62539c6d5b782a46.png";